import { FC, useEffect, useMemo, useCallback, useReducer } from 'react';
import { API, Endpoints } from '@brg/api';
import { useToasts } from '@brg/ui';
import { AppTester } from 'supporting';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { CheckboxRowWrapper, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { MagicBoxRow } from 'shared/components/MagicBoxRow';
import { useSelector } from 'react-redux';
import { CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'COMPETITION_TOGGLED': {
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    }
    case 'VALUES_REINITIALIZED': {
      const changedcompetitionIds = action.payload.reduce((result: any, competitionId: any) => {
        const { checked } = state[competitionId];
        return {
          ...result,
          [competitionId]: {
            ...state[competitionId],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedcompetitionIds,
      };
    }
    case 'VALUES_INITIALIZED':
      return {
        ...action.payload
      };
    default:
      return state;
  }
}

const toggleCompetition = (payload: any) => ({
  type: 'COMPETITION_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const initializeValues = (payload: any) => ({
  type: 'VALUES_INITIALIZED',
  payload,
})

type PropsT = {
  project: any;
  onClose?: () => void;
  fullWidth?: boolean;
};

export const ProjectCompetitionsPanel: FC<PropsT> = ({ project, onClose, fullWidth }) => {
  const toasts = useToasts();
  const isGeo = AppTester.isGeograffee();

  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector)

  const initialState = useMemo(() => competitions ? competitions.reduce((result, competition) => {
    //@ts-ignore
    const hasCompetition = !!project.competitionApproves?.find?.(({ competitionId }) => competitionId === competition.competitionId);
    return {
      ...result,
      [competition.competitionId]: {
        initialValue: hasCompetition,
        label: getCompetitionTitle(competition),
        checked: hasCompetition,
        changed: false,
      }
    }
  }, {}) : {}, [competitions, project]);

  const [state, dispatch] = useReducer<any>(reducer, {});

  useEffect(() => {
    dispatch(initializeValues(initialState));
  }, [initialState])

  const changedCompetitions = useMemo(() => {
    return Object.entries(state).reduce((result, [competition, { changed }]: [any, any]) => {
      if (changed) {
        return [...result, competition]
      }
      return result;
    }, [] as string[]);
  }, [state])

  const isButtonDisabled = !changedCompetitions.length;

  const handleOk = useCallback(() => {
    const dataCompetitions: any[] = [];

    Object.entries(state).forEach(([competition, {
      label,
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        dataCompetitions.push({
          competitionId: competition,
          operation: checked ? 1 : 0,
        })
        toasts.info(checked ? `Проект добавлен на конкурс ${label}` : `Проект убран из конкурса ${label}`);
      }
    })

    if (dataCompetitions.length) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url(`/api/Competition/UpdatePeojectCompetitions`)
        .post()
        .body({
          projectId: project.projectId,
          competitions: dataCompetitions,
        })
        .send()
        .then(() => {
          dispatch(reinitializeValues(changedCompetitions))
        })
    }
    onClose?.();
  }, [state, toasts, onClose, project.projectId, changedCompetitions]);

  const checkboxes = Object.entries(state).map(([competition, {
    checked,
    label
  }]: [any, any]) => (
    <CheckboxRowWrapper key={competition}>
      <MagicBoxRow
        onClick={() => dispatch(toggleCompetition(competition))}
        checked={checked}
        label={label}
      />
    </CheckboxRowWrapper>
  ))

  if (!checkboxes.length) {
    return null;
  }

  return (
    <Outer isGeo={isGeo} fullWidth={fullWidth}>
      <TooltipList>
        {checkboxes}
      </TooltipList>
      <OkButtonWrapper>
        <OkButton isGeo={isGeo} disabled={isButtonDisabled} onClick={handleOk}>Подтвердить</OkButton>
      </OkButtonWrapper>
    </Outer>
  );
};

export const useHasProjectCompetitions = (project: any) => {
  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector);
  return useMemo(() => !!competitions?.length, [competitions?.length]);
};
import { FC, useEffect, useMemo, useCallback, useReducer } from 'react';
import { API, Endpoints } from '@brg/api';
import { useToasts } from '@brg/ui';
import { AppTester } from 'supporting';
import { getCompetitionTitle } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { CheckboxRowWrapper, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { MagicBoxRow } from 'shared/components/MagicBoxRow';
import { useSelector } from 'react-redux';
import { CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'COMPETITION_TOGGLED': {
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    }
    case 'VALUES_REINITIALIZED': {
      const changedcompetitionIds = action.payload.reduce((result: any, competitionId: any) => {
        const { checked } = state[competitionId];
        return {
          ...result,
          [competitionId]: {
            ...state[competitionId],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedcompetitionIds,
      };
    }
    case 'VALUES_INITIALIZED':
      return {
        ...action.payload
      };
    default:
      return state;
  }
}

const toggleCompetition = (payload: any) => ({
  type: 'COMPETITION_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const initializeValues = (payload: any) => ({
  type: 'VALUES_INITIALIZED',
  payload,
})

type PropsT = {
  project: any;
  onClose?: () => void;
  fullWidth?: boolean;
};

export const ProjectCompetitionsPanel: FC<PropsT> = ({ project, onClose, fullWidth }) => {
  const toasts = useToasts();
  const isGeo = AppTester.isGeograffee();

  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector)

  const initialState = useMemo(() => competitions ? competitions.reduce((result, competition) => {
    //@ts-ignore
    const hasCompetition = !!project.competitionApproves?.find?.(({ competitionId }) => competitionId === competition.competitionId);
    return {
      ...result,
      [competition.competitionId]: {
        initialValue: hasCompetition,
        label: getCompetitionTitle(competition),
        checked: hasCompetition,
        changed: false,
      }
    }
  }, {}) : {}, [competitions, project]);

  const [state, dispatch] = useReducer<any>(reducer, {});

  useEffect(() => {
    dispatch(initializeValues(initialState));
  }, [initialState])

  const changedCompetitions = useMemo(() => {
    return Object.entries(state).reduce((result, [competition, { changed }]: [any, any]) => {
      if (changed) {
        return [...result, competition]
      }
      return result;
    }, [] as string[]);
  }, [state])

  const isButtonDisabled = !changedCompetitions.length;

  const handleOk = useCallback(() => {
    const dataCompetitions: any[] = [];

    Object.entries(state).forEach(([competition, {
      label,
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        dataCompetitions.push({
          competitionId: competition,
          operation: checked ? 1 : 0,
        })
        toasts.info(checked ? `Проект добавлен на конкурс ${label}` : `Проект убран из конкурса ${label}`);
      }
    })

    if (dataCompetitions.length) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url(`/api/Competition/UpdatePeojectCompetitions`)
        .post()
        .body({
          projectId: project.projectId,
          competitions: dataCompetitions,
        })
        .send()
        .then(() => {
          dispatch(reinitializeValues(changedCompetitions))
        })
    }
    onClose?.();
  }, [state, toasts, onClose, project.projectId, changedCompetitions]);

  const checkboxes = Object.entries(state).map(([competition, {
    checked,
    label
  }]: [any, any]) => (
    <CheckboxRowWrapper key={competition}>
      <MagicBoxRow
        onClick={() => dispatch(toggleCompetition(competition))}
        checked={checked}
        label={label}
      />
    </CheckboxRowWrapper>
  ))

  if (!checkboxes.length) {
    return null;
  }

  return (
    <Outer isGeo={isGeo} fullWidth={fullWidth}>
      <TooltipList>
        {checkboxes}
      </TooltipList>
      <OkButtonWrapper>
        <OkButton isGeo={isGeo} disabled={isButtonDisabled} onClick={handleOk}>Подтвердить</OkButton>
      </OkButtonWrapper>
    </Outer>
  );
};

export const useHasProjectCompetitions = (project: any) => {
  const { projectCompetitions: competitions } = useSelector(CompetitionProjectsSelector);
  return useMemo(() => !!competitions?.length, [competitions?.length]);
};
